// Copyright Materialize, Inc. and contributors. All rights reserved.
//
// Use of this software is governed by the Business Source License
// included in the LICENSE file.
//
// As of the Change Date specified in that file, in accordance with
// the Business Source License, use of this software will be governed
// by the Apache License, Version 2.0.

import { PostgreSQL, sql, SQLDialect } from "@codemirror/lang-sql";
import { getKeywords } from "@materializeinc/sql-lexer";

const mzKeywords = getKeywords();
const dialect = SQLDialect.define({
  ...PostgreSQL.spec,
  keywords: mzKeywords.join(" ").toLowerCase(),
});

export default sql({ dialect });
